import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
var _excluded = ["locale", "region"],
  _excluded2 = ["locale", "region"],
  _excluded3 = ["locale", "region"],
  _excluded4 = ["locale", "region"];
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import QS from 'qs';
import Base from './base';
import { UserItem, CompanyItem, RoleItem } from '../models';
import { getReqConfig, parsePagination } from '../utils/admin';
import { deprecatedWarning } from '../utils/commons';
import { DOCS_PRODUCTS } from '../utils/consts';

/**
 * `Service` The HQ service
 */
var HQ = /*#__PURE__*/function (_Base) {
  /**
   * Create the project service instance.
   *
   * @param sdk - the SDK instance
   */
  function HQ(sdk) {
    _classCallCheck(this, HQ);
    return _callSuper(this, HQ, [sdk]);
  }

  /**
   * Static getter of the class name
   *
   * @returns The detail property name used by SDK instance.
   */
  _inherits(HQ, _Base);
  return _createClass(HQ, [{
    key: "getProjectUsers",
    value: (
    /**
     * Get project users from hq api
     * https://platform.stoplight.autodesk.com/docs/hq-api-server/9f09848251a16-projects-p-id-users
     *
     * @param projectId -  the project id.
     * @param options - the query parameter options contains offset, limit, locale, region and other filter props.
     * @param config - Configurable object to overwrite request parameters.
     *
     * @returns a promise that resolve with user list and pagination info.
     *
     * @deprecated Please use Admin.getProjectUsers instead for ACC product
     */
    function () {
      var _getProjectUsers = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(projectId, options, config) {
        var _ref, _ref$locale, locale, _ref$region, region, rest, query, path, response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (this.Config.product === DOCS_PRODUCTS.ACC) {
                deprecatedWarning('HQ.getProjectUsers', 'Admin.getProjectUsers');
              }
              _ref = options || {}, _ref$locale = _ref.locale, locale = _ref$locale === void 0 ? this.Config.locale : _ref$locale, _ref$region = _ref.region, region = _ref$region === void 0 ? this.Config.region : _ref$region, rest = _objectWithoutProperties(_ref, _excluded);
              query = QS.stringify(_extends({
                limit: 200,
                offset: 0,
                fields: ['name', 'email', 'autodeskId', 'analyticsId', 'imageUrl', 'companyId', 'roleIds', 'accessLevels', 'services', 'status']
              }, rest), {
                addQueryPrefix: true,
                encodeValuesOnly: true,
                arrayFormat: 'comma'
              });
              path = "/projects/".concat(projectId, "/users").concat(query);
              _context.next = 6;
              return this.HttpService.adminV1.get(path, getReqConfig({
                locale: locale,
                region: region,
                config: config
              }));
            case 6:
              response = _context.sent;
              return _context.abrupt("return", {
                users: response.data.results.map(UserItem.parseHQ),
                pagination: parsePagination(response.data.pagination)
              });
            case 8:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getProjectUsers(_x, _x2, _x3) {
        return _getProjectUsers.apply(this, arguments);
      }
      return getProjectUsers;
    }()
    /**
     * Get project roles from hq api
     * https://platform.stoplight.autodesk.com/docs/hq-api-server/861e4ccd19c18-projects-p-id-roles
     *
     * @param projectId -  the project id.
     * @param options - the query parameter options contains offset, limit, locale, region and other filter props.
     * @param config - Configurable object to overwrite request parameters.
     *
     * @returns a promise that resolve with role list and pagination info.
     */
    )
  }, {
    key: "getProjectRoles",
    value: (function () {
      var _getProjectRoles = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(projectId, options, config) {
        var _ref2, _ref2$locale, locale, _ref2$region, region, rest, query, path, response;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _ref2 = options || {}, _ref2$locale = _ref2.locale, locale = _ref2$locale === void 0 ? this.Config.locale : _ref2$locale, _ref2$region = _ref2.region, region = _ref2$region === void 0 ? this.Config.region : _ref2$region, rest = _objectWithoutProperties(_ref2, _excluded2);
              query = QS.stringify(_extends({
                limit: 200,
                offset: 0,
                fields: ['memberGroupId', 'name', 'status']
              }, rest), {
                addQueryPrefix: true,
                encodeValuesOnly: true,
                arrayFormat: 'comma'
              });
              path = "/projects/".concat(projectId, "/roles").concat(query);
              _context2.next = 5;
              return this.HttpService.adminV1.get(path, getReqConfig({
                locale: locale,
                region: region,
                config: config
              }));
            case 5:
              response = _context2.sent;
              return _context2.abrupt("return", {
                roles: response.data.results.map(RoleItem.parseHQ),
                pagination: parsePagination(response.data.pagination)
              });
            case 7:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getProjectRoles(_x4, _x5, _x6) {
        return _getProjectRoles.apply(this, arguments);
      }
      return getProjectRoles;
    }()
    /**
     * Get project companies from hq api
     * https://platform.stoplight.autodesk.com/docs/hq-api-server/0ff108d8011ee-projects-p-id-companies
     *
     * @param projectId -  the project id.
     * @param options - the query parameter options contains offset limit, locale, region and other filter props.
     * @param config - Configurable object to overwrite request parameters.
     *
     * @returns a promise that resolve with company list and pagination info.
     */
    )
  }, {
    key: "getProjectCompanies",
    value: (function () {
      var _getProjectCompanies = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(projectId, options, config) {
        var _ref3, _ref3$locale, locale, _ref3$region, region, rest, query, path, response;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _ref3 = options || {}, _ref3$locale = _ref3.locale, locale = _ref3$locale === void 0 ? this.Config.locale : _ref3$locale, _ref3$region = _ref3.region, region = _ref3$region === void 0 ? this.Config.region : _ref3$region, rest = _objectWithoutProperties(_ref3, _excluded3);
              query = QS.stringify(_extends({
                limit: 200,
                offset: 0,
                fields: ['memberGroupId', 'name', 'status', 'imageUrl']
              }, rest), {
                addQueryPrefix: true,
                encodeValuesOnly: true,
                arrayFormat: 'comma'
              });
              path = "/projects/".concat(projectId, "/companies").concat(query);
              _context3.next = 5;
              return this.HttpService.adminV1.get(path, getReqConfig({
                locale: locale,
                region: region,
                config: config
              }));
            case 5:
              response = _context3.sent;
              return _context3.abrupt("return", {
                companies: response.data.results.map(CompanyItem.parseHQ),
                pagination: parsePagination(response.data.pagination)
              });
            case 7:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function getProjectCompanies(_x7, _x8, _x9) {
        return _getProjectCompanies.apply(this, arguments);
      }
      return getProjectCompanies;
    }()
    /**
     * Get account users from hq api
     * https://platform.stoplight.autodesk.com/docs/hq-api-server/46a3cf0a83ba3-accounts-a-id-users
     *
     * @param accountId - the account id.
     * @param options - the query parameter options contains offset, limit, locale, region and other filter props.
     * @param config - Configurable object to overwrite request parameters.
     *
     * @returns a promise that resolve with user list and pagination info.
     */
    )
  }, {
    key: "getAccountUsers",
    value: (function () {
      var _getAccountUsers = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(accountId, options, config) {
        var _ref4, _ref4$locale, locale, _ref4$region, region, rest, query, path, response;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _ref4 = options || {}, _ref4$locale = _ref4.locale, locale = _ref4$locale === void 0 ? this.Config.locale : _ref4$locale, _ref4$region = _ref4.region, region = _ref4$region === void 0 ? this.Config.region : _ref4$region, rest = _objectWithoutProperties(_ref4, _excluded4);
              query = QS.stringify(_extends({
                limit: 200,
                offset: 0,
                fields: ['name', 'email', 'autodeskId', 'analyticsId', 'imageUrl', 'companyId', 'roleIds', 'accessLevels', 'services', 'status']
              }, rest), {
                addQueryPrefix: true,
                encodeValuesOnly: true,
                arrayFormat: 'comma'
              });
              path = "/accounts/".concat(accountId, "/users").concat(query);
              _context4.next = 5;
              return this.HttpService.adminV1.get(path, getReqConfig({
                locale: locale,
                region: region,
                config: config
              }));
            case 5:
              response = _context4.sent;
              return _context4.abrupt("return", {
                users: response.data.results.map(UserItem.parseHQ),
                pagination: parsePagination(response.data.pagination)
              });
            case 7:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function getAccountUsers(_x10, _x11, _x12) {
        return _getAccountUsers.apply(this, arguments);
      }
      return getAccountUsers;
    }()
    /**
     * get project entitlements
     * https://platform.stoplight.autodesk.com/docs/hq-api-server/41b47cbb76c64-project-entitlements
     *
     * @param options - the query parameter options contains offset limit.
     * @param config - Configurable object to overwrite request parameters
     * @returns a promise with HQ projects list
     */
    )
  }, {
    key: "getProjectEntitlements",
    value: (function () {
      var _getProjectEntitlements = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5(options, config) {
        var query, response;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              query = QS.stringify(_extends({
                limit: 200,
                offset: 0,
                fields: ['name', 'accountName', 'imageUrl', 'products']
              }, options), {
                addQueryPrefix: true,
                encodeValuesOnly: true,
                arrayFormat: 'comma'
              });
              _context5.next = 3;
              return this.HttpService.adminV2.get("/project-entitlements".concat(query), config);
            case 3:
              response = _context5.sent;
              return _context5.abrupt("return", response.data || {});
            case 5:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function getProjectEntitlements(_x13, _x14) {
        return _getProjectEntitlements.apply(this, arguments);
      }
      return getProjectEntitlements;
    }())
  }], [{
    key: "getName",
    value: function getName() {
      return 'HQ';
    }
  }]);
}(Base);
export default HQ;